if (typeof (window) !== 'undefined' && !window.dataLayer) { window.dataLayer = [] }

export default function trackEvent(evt) {
  const eventName = evt.event
  const data = evt

  if (window.dataLayer) { window.dataLayer.push(evt) }

  if (window.mixpanel) {
    window.mixpanel.track(eventName, data)
  } else {
    console.log('trackEvent', eventName, data)
  }

  if (typeof window.ga === 'function') {
    window.ga('send', 'event', eventName, data)
  }

  const { FB } = window
  if (FB && FB.AppEvents) {
    try {
      FB.AppEvents.logEvent(eventName, null, data)
    } catch (e) {
      console.error(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/trackEvent.js